/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  GREEN_MARKER_COLOR,
  rendererColorCircle,
  rendererIconByName,
  ROW_DELETED_CLASS, ROW_DIRTY_CLASS,
  truthyCellRenderer,
} from '@gh/common-internal-shared';
import { DateTimeTypes, NumberTypes } from '@gh/common-shared';
import {
  buildDateTimeColumn,
  buildNumberColumn,
  LayoutBasedGridDefinition,
} from '@gh/core-ui-grid';
import { FeeExclusionItemDto } from '@gh/builder-shared-data';

@Injectable()
export class FeeExclusionsGridDefinition extends LayoutBasedGridDefinition {

  columnDefs = {
    formula: {
      cellRenderer: truthyCellRenderer(rendererColorCircle(GREEN_MARKER_COLOR)),
    },
    picture: {
      cellRenderer: truthyCellRenderer(rendererColorCircle(GREEN_MARKER_COLOR)),
    },
    salesTax: {
      cellRenderer: truthyCellRenderer(rendererIconByName('done')),
    },
    costUpdated: buildDateTimeColumn(DateTimeTypes.Timestamp),
    cost: buildNumberColumn(NumberTypes.Price),
  };

  options = {
    rowClassRules: {
      [ROW_DELETED_CLASS]: ({ data }: { data: FeeExclusionItemDto }) => data.active !== true,
      [ROW_DIRTY_CLASS]: ({ data }: { data: FeeExclusionItemDto }) =>
        data.active === true && data.isNew === true,
    },
    getRowId: (params) => String(params.data.id),
  };
}
